import BackToTop from './BackToTop';
export default BackToTop;
//# sourceMappingURL=index.js.map